const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const getRequests = async() => {
    const requestOptions = {
        method: 'GET',
        redirect: 'follow' as RequestRedirect
    };

    return fetch(`${API_BASE_URL}/requests`, requestOptions)
        .then(response => response.json())
}